/**
 * Identidad visual a partir de un nombre (organización, persona).
 *
 * - `getInitials(name)` → 1-2 letras.
 * - `getAvatarColor(name)` → hash determinista contra paleta muted de 8 colores.
 *
 * Se usa en OrgSwitcher, UserMenu, lista de personas, tablas de gobierno.
 */

const AVATAR_COLORS = [
  { bg: 'bg-blue-100',     fg: 'text-blue-700',     dark: 'dark:bg-blue-900/40 dark:text-blue-200' },
  { bg: 'bg-emerald-100',  fg: 'text-emerald-700',  dark: 'dark:bg-emerald-900/40 dark:text-emerald-200' },
  { bg: 'bg-amber-100',    fg: 'text-amber-700',    dark: 'dark:bg-amber-900/40 dark:text-amber-200' },
  { bg: 'bg-rose-100',     fg: 'text-rose-700',     dark: 'dark:bg-rose-900/40 dark:text-rose-200' },
  { bg: 'bg-violet-100',   fg: 'text-violet-700',   dark: 'dark:bg-violet-900/40 dark:text-violet-200' },
  { bg: 'bg-cyan-100',     fg: 'text-cyan-700',     dark: 'dark:bg-cyan-900/40 dark:text-cyan-200' },
  { bg: 'bg-teal-100',     fg: 'text-teal-700',     dark: 'dark:bg-teal-900/40 dark:text-teal-200' },
  { bg: 'bg-pink-100',     fg: 'text-pink-700',     dark: 'dark:bg-pink-900/40 dark:text-pink-200' },
] as const

export function getInitials(name: string | null | undefined): string {
  if (!name) return '?'
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return '?'
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return (words[0][0] + words[words.length - 1][0]).toUpperCase()
}

export function getAvatarColor(name: string | null | undefined): { bg: string; fg: string; dark: string } {
  if (!name) return AVATAR_COLORS[0]
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash) + name.charCodeAt(i)
    hash |= 0
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

export function avatarClasses(name: string | null | undefined): string {
  const c = getAvatarColor(name)
  return `${c.bg} ${c.fg} ${c.dark}`
}
